import { AlertCircle } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Logo } from "@/components/Logo";

export function SignIn() {
  const { signIn, accessError } = useAuth();

  return (
    <div className="flex h-full items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <Logo className="mb-1" />
          <CardTitle className="sr-only">Sign in to Pinpoint</CardTitle>
          <CardDescription>
            Outbound pipeline intelligence for bippit
          </CardDescription>
        </CardHeader>

        <CardContent className="flex flex-col gap-4">
          {accessError ? (
            <Alert variant="destructive">
              <AlertCircle />
              <AlertTitle>Access denied</AlertTitle>
              <AlertDescription>{accessError}</AlertDescription>
            </Alert>
          ) : null}

          <Button onClick={signIn} className="w-full" size="lg">
            <GoogleMark />
            Continue with Google
          </Button>

          <p className="text-center text-xs leading-relaxed text-muted-foreground">
            Restricted to members of the Pinpoint group on bippit.com
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

function GoogleMark() {
  return (
    <svg viewBox="0 0 24 24" className="size-4" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M23.5 12.27c0-.85-.08-1.67-.22-2.45H12v4.63h6.45a5.5 5.5 0 0 1-2.39 3.62v3h3.86c2.26-2.08 3.58-5.15 3.58-8.8Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.95-1.07 7.93-2.91l-3.87-3a7.2 7.2 0 0 1-10.72-3.78H1.36v3.09A12 12 0 0 0 12 24Z"
      />
      <path
        fill="#FBBC05"
        d="M5.34 14.31a7.2 7.2 0 0 1 0-4.6V6.62H1.36a12 12 0 0 0 0 10.77l3.98-3.08Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.43-3.43C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.36 6.62l3.98 3.09A7.2 7.2 0 0 1 12 4.75Z"
      />
    </svg>
  );
}
